import { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchJobs } from '../store/jobThunk';
import { setFilters } from '../store/jobSlice';

import type { JobFilters } from '../types/job';
import type { RootState, AppDispatch } from '@/store/store';

export const useJobs = (
  initialFilters: JobFilters = {}
) => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    jobs,
    loading,
    error,
    pagination,
    selectedJob,
    filters,
  } = useSelector(
    (state: RootState) => state.jobs
  );

  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) {
      return;
    }

    initializedRef.current = true;

    if (Object.keys(initialFilters).length > 0) {
      dispatch(setFilters(initialFilters));
    }
  }, [dispatch, initialFilters]);

  useEffect(() => {
    dispatch(fetchJobs(filters));
  }, [dispatch, filters]);

  const updateFilters = useCallback(
    (newFilters: Partial<JobFilters>) => {
      dispatch(setFilters(newFilters));
    },
    [dispatch]
  );

  const refreshJobs = useCallback(() => {
    dispatch(fetchJobs(filters));
  }, [dispatch, filters]);

  return {
    jobs,
    loading,
    error,
    pagination,
    selectedJob,
    filters,
    updateFilters,
    refreshJobs,
  };
};